export const getMarginProps = props => {
  return {
    margin: props.margin,
    marginBlock: props.marginBlock,
    marginBlockEnd: props.marginBlockEnd,
    marginBlockStart: props.marginBlockStart,
    marginInline: props.marginInline,
    marginInlineEnd: props.marginInlineEnd,
    marginInlineStart: props.marginInlineStart
  };
};
export const getBorderProps = props => {
  return {
    borderWidth: props.borderWidth,
    borderColor: props.borderColor,
    borderStyle: props.borderStyle
  };
};